export interface GallerySlide {
  src: string
  alt: string
  title: string
  caption: string
}

const IMG_BASE =
  'https://sb.impultienda.ar/storage/v1/object/public/ebook-images/4131350a-9ef1-48f0-8188-046dddb3074d/product-uploads/'

export const insideItems: string[] = [
  'Anatomy of a bar & the workstation',
  'Essential bar tools, labeled',
  'Glassware families & capacities',
  'Ice types & dilution',
  'Jigger accuracy & free pouring',
  'Shake vs. stir decision rules',
  'Straining, muddling & dry shaking',
  'How to read a cocktail spec',
  'The golden ratio for sours',
  'Cocktail families map',
  'Classic cocktail specs in ml & oz',
  'Zero-proof classics',
  'Syrups, infusions & shrubs',
  'Clarification & carbonation',
  'Foams, smoke & aroma',
  'Creating a signature cocktail',
  'How spirits are made',
  'Gin botanicals & whisky styles',
  'Liqueurs, bitters & mixers',
  'Spirits tasting grid',
  'Garnish techniques step by step',
  'Cocktail menu design',
  'Costing & pour cost',
  'Inventory & bar operations',
  'Responsible alcohol service',
  'Lesson plans by level',
  'Practical exams & rubrics',
  '❌/✅ comparisons',
  'Teaching cues, drills & quick checks',
  'Bartending training programs',
]

/** Carousel slides — one real page per volume (Vol 1 to Vol 6). */
export const gallerySlides: GallerySlide[] = [
  {
    src: `${IMG_BASE}mcp_933f964e-bb4f-41ec-b86a-32a166415395_1793726240718.jpg`,
    alt: 'Bartending & Mixology Instructor Atlas — Vol 1 page: Glassware Families, silhouettes, names and typical capacities of 12 bar glasses',
    title: 'Vol 1 — Glassware Families',
    caption: 'Vol 1 — Bartending Fundamentals, Bar Tools, Glassware & Essential Techniques: 12 glass shapes with capacities in ml and oz, plus an instructor cue.',
  },
  {
    src: `${IMG_BASE}mcp_49a92b37-ba6f-4770-ac8f-0784cbd2078b_1793726243892.png`,
    alt: 'Bartending & Mixology Instructor Atlas — Vol 2 page: Margarita classic spec, step-by-step build, mistake vs. correct, cue, drill and quick check',
    title: 'Vol 2 — Margarita',
    caption: 'Vol 2 — Classic Cocktails, International Recipes & Drink Preparation: classic spec in ml/oz, 5-step build, ❌/✅ salt rim, drill and quick check.',
  },
  {
    src: `${IMG_BASE}mcp_2eb522f9-2ed4-4dab-8a44-6f0a4dbdad15_1793737790562.jpg`,
    alt: 'Bartending & Mixology Instructor Atlas — Vol 3 page: Rich & Flavored Syrups, syrup ratio grid, storage and labeling rules',
    title: 'Vol 3 — Rich & Flavored Syrups',
    caption: 'Vol 3 — Advanced Mixology, Molecular Techniques & Creative Cocktails: rich, demerara, honey, maple and agave syrup ratios, storage rules, cue, drill and quick check.',
  },
  {
    src: `${IMG_BASE}mcp_b7ec2288-a450-4aae-92e8-05b730299e83_1793737793160.jpg`,
    alt: 'Bartending & Mixology Instructor Atlas — Vol 4 page: Distillation, pot still vs. column still with labeled diagrams',
    title: 'Vol 4 — Pot Still vs. Column Still',
    caption: 'Vol 4 — Spirits, Liqueurs, Flavor Profiles & Sensory Analysis: labeled still diagrams, process, output and typical spirits, with a ❌/✅ comparison and instructor cue.',
  },
  {
    src: `${IMG_BASE}mcp_cc7fa50e-ef88-4a6a-a2ef-7893867ccc1d_1793737795733.jpg`,
    alt: 'Bartending & Mixology Instructor Atlas — Vol 5 page: Wheels, Wedges & Half-Moons, step-by-step citrus cutting and placement guide',
    title: 'Vol 5 — Wheels, Wedges & Half-Moons',
    caption: 'Vol 5 — Cocktail Presentation, Garnishing, Menu Design & Bar Operations: 6-step citrus cutting and rim placement guide, ❌/✅, cue, drill and quick check.',
  },
  {
    src: `${IMG_BASE}mcp_933f964e-bb4f-41ec-b86a-32a166415395_1793737798712.jpg`,
    alt: 'Bartending & Mixology Instructor Atlas — Vol 6 page: Lesson Plan, Stirred Classics with specs, practice drill and assessment drill',
    title: 'Vol 6 — Lesson Plan: Stirred Classics',
    caption: 'Vol 6 — Bartending Instruction, Training Programs & Practical Assessments: a 60-minute lesson plan with classic specs, a timed practice drill and an assessment drill.',
  },
]
